export default "__VITE_ASSET__DtbtHm_O__"